import { v7 as uuidv7 } from 'uuid';
import { z } from 'zod';
const brand = () => z.string().uuid().brand();
export const tenantIdSchema = brand();
export const userIdSchema = brand();
export const productIdSchema = brand();
export const categoryIdSchema = brand();
export const orderIdSchema = brand();
export const orderItemIdSchema = brand();
export const paymentIdSchema = brand();
export const cashSessionIdSchema = brand();
export const invoiceIdSchema = brand();
export const customerIdSchema = brand();
export const taxRateIdSchema = brand();
export const dianResolutionIdSchema = brand();
export const newId = (schema) => schema.parse(uuidv7());
//# sourceMappingURL=index.js.map